import styled, { css } from 'styled-components';

interface IProps {
  disabled?: boolean;
  selected?: boolean;
  fullHeight?: boolean;
  disabledBackgroundColor?: string;
}

export const ButtonIconVerticalStyled = styled.div<IProps>`
  .Polaris-ShadowBevel {
    &::before {
      border: ${({ selected }) => (selected ? '1px solid' : 'none')};
    }
    .Polaris-Box {
      :hover {
        background-color: ${({ disabled, disabledBackgroundColor }) =>
          disabled ? disabledBackgroundColor || '#e5e5e5' : '#fafafa'};
      }
      cursor: pointer;
      .custom-card-content,
      .custom-card-header > div {
        display: flex;
        justify-content: center;
        .custom-card-title > div > div:nth-child(2) {
          margin-top: 0;
          font-size: 13px;
          font-weight: bold;
        }
      }
      .custom-card-content > span {
        text-align: center;
      }
      .card-icon {
        text-align: center;
      }
      ${({ disabled, disabledBackgroundColor }) =>
        disabled &&
        css`
          opacity: 0.5;
          cursor: not-allowed;
          background-color: ${disabledBackgroundColor || '#e5e5e5'};
        `}
    }
  }

  ${({ fullHeight }) =>
    fullHeight &&
    css`
      height: 100%;
      .custom-card {
        height: 100%;
        .Polaris-ShadowBevel {
          height: 100%;
          .Polaris-Box {
            height: 100%;
          }
        }
      }
    `}
`;
